import { Dispatch } from "redux";
import { AccountService } from "@Services";
import { ILogin, SignupRequest } from "@Interfaces";
import { actions } from "./index";
import { IRenewPassword } from "@Interfaces";
import { IForgotPassword } from "@Interfaces";
import authHeaders from "@Services/Auth/token";

const {
    authInvalid,
    authFailure,
    authSuccess,
    setAccessData,
    authSnackbar,
    setAccountIsTaken,
    setUserRestrictions,
} = actions;

const setAutheticatedUser =
    ({ jwt_token_expiry, jwt_token, user }: any): any =>
    async (dispatch: Dispatch) => {
        authHeaders(jwt_token ?? null);
        dispatch(setAccessData({ jwt_token_expiry, jwt_token, user }));
        dispatch(authSuccess());

        try {
            const { data } = await AccountService.userInfo(jwt_token);

            //@todo We need to split login/ and user/me
            const userInfo = {
                account: data.account,
                account_type: data.account_type,
                restrictions: data.restrictions,
                avatar: data.avatar,
            };

            dispatch(setUserRestrictions(userInfo));
        } catch (e) {
            console.error(e);
        }
    };

const setAuthSnackbar =
    ({ snackbarOpen, snackbarType, snackbarMessage }: any): any =>
    async (dispatch: Dispatch) => {
        dispatch(authSnackbar({ snackbarOpen, snackbarType, snackbarMessage }));
    };

const Signup = (requestBody: SignupRequest) => async (dispatch: Dispatch) => {
    try {
        const { data } = await AccountService.createUserAccount(requestBody);

        dispatch(setAutheticatedUser(data));
    } catch (e) {
        dispatch(authFailure());
        console.error(e);
    }
};

const IsAccountTaken =
    (requestBody: SignupRequest) => async (dispatch: Dispatch) => {
        try {
            await AccountService.isUserNameEmailTaken(
                requestBody.username,
                requestBody.email
            );

            Signup(requestBody)(dispatch);
        } catch (e) {
            dispatch(setAccountIsTaken(true));
        }
    };

const Logout = () => async (dispatch: Dispatch) => {
    try {
        await AccountService.logoutUserAccount();
        authHeaders(null);
        dispatch(authInvalid());
    } catch (e) {
        authHeaders(null);
        dispatch(authInvalid());
    }
};

const Reauthenticate = () => async (dispatch: Dispatch) => {
    try {
        const { data } = await AccountService.refreshUserToken();

        dispatch(setAutheticatedUser(data));
    } catch (e) {
        authHeaders(null);
        dispatch(authInvalid());
    }
};

const PostLoginAccount =
    (payload: ILogin.Actions.ILoginUserRequest) =>
    async (dispatch: Dispatch) => {
        try {
            const { data } = await AccountService.loginUserAccount(payload);
            dispatch(setAutheticatedUser(data));
        } catch (e) {
            dispatch(authFailure());
            dispatch(
                setAuthSnackbar({
                    snackbarOpen: true,
                    snackbarType: "error",
                    snackbarMessage: "Oops! Your credentials do not match.",
                })
            );
        }
    };

const PostLoginAccountGoogle =
    (payload: ILogin.Actions.ILoginUserGoogleRequest) =>
    async (dispatch: Dispatch) => {
        try {
            const result = await AccountService.loginUserGoogleAccount(payload);
            const { data } = result;

            dispatch(setAutheticatedUser(data));
        } catch (e) {
            dispatch(authFailure());
        }
    };

const PostLoginAccountFacebook =
    (payload: ILogin.Actions.ILoginUserGoogleRequest) =>
    async (dispatch: Dispatch) => {
        try {
            const result = await AccountService.loginUserGoogleAccount(payload);
            const { data } = result;

            dispatch(setAutheticatedUser(data));
        } catch (e) {
            dispatch(authFailure());
        }
    };

const PostRenewAccount =
    (payload: IRenewPassword.Actions.IRenewPasswordUserRequest) => async () => {
        try {
            await AccountService.renewPassword(payload);
        } catch (e) {
            console.error(e);
        }
    };
const PostForgotAccount =
    (payload: IForgotPassword.Actions.IForgotPasswordUserRequest) =>
    async (dispatch: Dispatch) => {
        try {
            await AccountService.forgotPassword(payload);
        } catch (e) {
            console.error(e);
        }
    };

export default {
    Signup,
    IsAccountTaken,
    Logout,
    Reauthenticate,
    PostLoginAccount,
    PostLoginAccountGoogle,
    PostLoginAccountFacebook,
    PostRenewAccount,
    PostForgotAccount,
};
